// extracted by mini-css-extract-plugin
module.exports = {"title":"PersonRecovery_title__r6Tga","text":"PersonRecovery_text__t8YcB","wrapper":"PersonRecovery_wrapper__mKJ7U"};